import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import ImageBox from "../../components/Image";
import useUserInfo from "../../routers/useUserInfo";
import Sex from "./sex";
import DatePickerBox from "./datePicker";
import {UserStorage} from "../../units";
import {useLoading} from "../../components/loading/LoadingProvider";
import {postUserBirthday, postUserRegion} from "../../service";
import ActionSheet from "../../components/actionSheet";
import {userInfoAction} from "../../store/actions";
import {useDispatch} from "react-redux";

const tfTime = (userInfo: UserStorage): Date | undefined => {
    if (userInfo.birthday) {
        return new Date(Date.parse(userInfo.birthday.replace(/-/g, "/")))
    }
    return undefined
}

const list = ['中国地区','港澳台地区','其他国家']

function ResumeUserInfo(){

    const userData = useUserInfo()
    const loading = useLoading()
    const  dispatch = useDispatch()

    const timeChange = (time: string) => {
        if (userData) {
            postUserBirthday({
                userId: userData.id,
                birthday: time
            }).then(res => {
                if (res.code === 1) {
                    loading.showSuccess()
                }
            })
        }
    }

    const regionChange = (s:string) => {
        if(userData){
            const region = list.findIndex(item => item === s).toString()
            postUserRegion({
                userId:userData.id,
                region
            }).then(res => {
                if(res.code === 1){
                    dispatch(userInfoAction(Object.assign({},userData,{ region })))
                    loading.showSuccess()
                }else{
                    loading.showError(res.msg)
                }
            })
        }

    }



    return <div className='user resume-modify'  style={{height: '100vh'}}>
        <div className="lists">

            <Link to={'/user/info/resume/name'}>
                <div className="name">
                    <p className='title'>真实姓名</p>
                </div>
                <p>
                    <span className="text">{userData?.fullName}</span>
                    <span className="iconfont">&#xe608;</span>
                </p>
            </Link>

            <Link to={'/user/info/resume/photo'}>
                <div className="name">
                    <p className='title'>简历照片</p>
                </div>
                <div>
                    <div style={{display: "inline-block", width: '.9rem', margin: '-.1rem .1rem'}}>
                        <ImageBox radius={50} src={userData?.photo} height={100}/>
                    </div>
                    <span className="iconfont">&#xe608;</span>
                </div>
            </Link>

            <div className='a'>
                <div className="name">
                    <p className='title'>用户性别</p>
                </div>
                <Sex sex={userData ? userData.sex !== undefined ? userData.sex : -1 : -1}/>
            </div>
            <div className='a' style={{padding: '.08rem 0 .08rem .3rem'}}>
                <div className="name">
                    <p className='title'>出生日期</p>
                </div>
                <DatePickerBox value={userData ? tfTime(userData) : undefined} onChange={timeChange}/>
            </div>

            <div className='a'>
                <div className="name">
                    <p className='title'>用户地区</p>
                </div>
                <ActionSheet label={'选择地区'} onChange={ (s) => regionChange(s) } list={ list } value={ userData?.region || 0 } placeholder={ '请选择地区' }/>
            </div>

        </div>
    </div>
}

export default ResumeUserInfo
